export default {
  title: 'Nuovo menu',
  headers: {
    edit_time: 'Modifica orario',
  },
  labels: {
    select_all: 'Seleziona tutto',
  },
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Inserisci nome menu',
    },
    sorting_order: {
      label: 'Ordine di visualizzazione menu',
      placeholder: 'Inserisci ordine di visualizzazione menu',
    },
    has_separate_schedule: {
      label: 'Diverso dagli orari di apertura regolari',
    },
    selected_days: {
      label: 'Giorni selezionati',
    },
    opening_time: {
      label: 'Orario di apertura',
    },
    closing_time: {
      label: 'Orario di chiusura',
    },
  },
  buttons: {
    add_opening_time: 'Aggiungi orario di apertura',
    add: 'Aggiungi',
    cancel: 'Annulla',
    save: 'Salva',
    close: 'Chiudi',
  },
  feedback: {
    missing_info: 'Informazioni mancanti',
  },
  toasts: {
    menu_got_created: 'Menu creato',
    menu_got_updated: 'Menu aggiornato',
  },
};
